import {
  CircleNotch,
  Microphone,
  MicrophoneSlash,
} from "@phosphor-icons/react";
import clsx from "clsx";

interface MicrophonePermissionNoticeProps {
  status: "denied" | "prompt";
  isRequesting: boolean;
}

const STATUS_CONFIG = {
  prompt: {
    label: "Microphone access is required to continue",
    icon: Microphone,
    className: "bg-purple-50 text-purple-500",
  },
  denied: {
    label: "Microphone access denied",
    icon: MicrophoneSlash,
    className: "bg-red-50 text-red-500",
  },
  requesting: {
    label: "Requesting microphone permission...",
    icon: CircleNotch,
    className: "bg-gray-50 text-gray-500",
  },
} as const;

export default function MicrophonePermissionNotice({
  status,
  isRequesting,
}: MicrophonePermissionNoticeProps) {
  const {
    label,
    icon: Icon,
    className,
  } = STATUS_CONFIG[isRequesting ? "requesting" : status];

  return (
    <div
      className={clsx(
        "flex items-center gap-3 rounded-full px-3 py-2 text-sm lg:mb-3",
        className,
      )}
    >
      <div className="flex flex-row items-center gap-x-1">
        <Icon size={16} className={clsx(isRequesting && "animate-spin")} />
        <span>{label}</span>
      </div>
    </div>
  );
}
